(function () {
	const initTextSlider = () => {
		const sliders = document.querySelectorAll('.text-slider-bar[data-section-id]');

		sliders.forEach((slider) => {
			const slides = slider.querySelectorAll('.text-slider-bar__slide');
			
			// Si hay menos de 2 slides, no hacer nada
			if (slides.length < 2) {
				return;
			}

			const slideDuration = parseInt(slider.dataset.slideDuration, 10) || 4000;
			const transitionEffect = slider.dataset.transitionEffect || 'fade';
			
			let currentIndex = 0;
			let intervalId = null;

			const showSlide = (index) => {
				slides.forEach((slide, i) => {
					if (i === index) {
						slide.classList.add('text-slider-bar__slide--active');
					} else {
						slide.classList.remove('text-slider-bar__slide--active');
					}
				});
			};

			const nextSlide = () => {
				currentIndex = (currentIndex + 1) % slides.length;
				showSlide(currentIndex);
			};

			const startSlider = () => {
				if (intervalId) {
					clearInterval(intervalId);
				}
				intervalId = setInterval(nextSlide, slideDuration);
			};

			const stopSlider = () => {
				if (intervalId) {
					clearInterval(intervalId);
					intervalId = null;
				}
			};

			// Pausar cuando el usuario interactúa con la página (hover)
			slider.addEventListener('mouseenter', stopSlider);
			slider.addEventListener('mouseleave', startSlider);

			// Pausar cuando la página no está visible
			document.addEventListener('visibilitychange', () => {
				if (document.hidden) {
					stopSlider();
				} else {
					startSlider();
				}
			});

			// Iniciar el slider
			startSlider();
		});
	};

	// Inicializar cuando el DOM esté listo
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initTextSlider);
	} else {
		initTextSlider();
	}

	// Reinicializar cuando Shopify cargue una sección
	document.addEventListener('shopify:section:load', function (event) {
		if (event.detail.sectionId) {
			const section = document.querySelector(`#shopify-section-${event.detail.sectionId}`);
			if (section && section.querySelector('.text-slider-bar')) {
				initTextSlider();
			}
		}
	});
})();

